<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main cost-custom-modal">
      <div class="title-area" id="modal-moving">
        <h2>見積価格設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li>
            <div class="radio-area">
              <span class="radio"><label><input type="radio" v-model="priceType" :value="1">積算価格</label></span>
              <span class="radio"><label><input type="radio" v-model="priceType" :value="2">定価（設定上代）</label></span>
            </div>
          </li>
          <hr/>
          <li>
            <span class="label">製品価格</span>
            <span class="label price">{{ retailPrice.toLocaleString() }}</span>
          </li>
          <li>
            <span class="label">配送費</span>
            <span class="label price">{{ deliveryCost.toLocaleString() }}</span>
          </li>
          <li>
            <span class="label">組立設置費</span>
            <span class="label price">{{ executionCost.toLocaleString() }}</span>
          </li>
          <hr/>
          <li v-for="(num, index) in 5" :key="index">
            <span class="label">{{ customNameList[num-1] }}</span>
            <input type="number" class="bs-input" v-model.number="costCustom[num]" :placeholder="customNameList[num-1]">
          </li>
          <hr/>
          <li>
            <span class="label">価格設定反映後の合計金額</span>
            <span class="label price">{{ totalPrice.toLocaleString() }}</span>
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustom1'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustom2'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustom3'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustom4'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['costCustom5'] }}</p>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateCostCustom">OK</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetCostCustomModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      modalInit: true,
      /** 構成明細カスタム名一覧 */
      customNameList: [],
      /** プラン価格情報 */
      planPriceData: {
        RETAIL_PRICE4: 0,
        REGRET_PRICE1: 0,
        DELIVERY_COST: 0,
        EXECUTION_COST: 0
      },
      priceType: 1,
      costCustom: {1: 0, 2: 0, 3: 0, 4: 0, 5: 0},
      validateErrorMessages: {}
    }
  },
  computed: {
    retailPrice: function () {
      if (this.priceType === 1) {
        return this.planPriceData.RETAIL_PRICE4
      } else {
        return this.planPriceData.REGRET_PRICE1
      }
    },
    deliveryCost: function () {
      return this.planPriceData.DELIVERY_COST
    },
    executionCost: function () {
      return this.planPriceData.EXECUTION_COST
    },
    totalPrice: function () {
      const costCustom1 = this.checkEmpty(this.costCustom[1])
      const costCustom2 = this.checkEmpty(this.costCustom[2])
      const costCustom3 = this.checkEmpty(this.costCustom[3])
      const costCustom4 = this.checkEmpty(this.costCustom[4])
      const costCustom5 = this.checkEmpty(this.costCustom[5])
      return this.retailPrice + this.deliveryCost + this.executionCost +
        costCustom1 + costCustom2 + costCustom3 + costCustom4 + costCustom5
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    fileData: function () {
      if (this.fileData.planDataModel) {
        this.costCustom[1] = this.checkEmpty(this.fileData.planDataModel.planCustomCost1)
        this.costCustom[2] = this.checkEmpty(this.fileData.planDataModel.planCustomCost2)
        this.costCustom[3] = this.checkEmpty(this.fileData.planDataModel.planCustomCost3)
        this.costCustom[4] = this.checkEmpty(this.fileData.planDataModel.planCustomCost4)
        this.costCustom[5] = this.checkEmpty(this.fileData.planDataModel.planCustomCost5)
      }
    },
    planPriceData: function () {
      if (this.planPriceData.RETAIL_PRICE4 || this.planPriceData.REGRET_PRICE1 || !this.modalInit) {
        this.$nextTick(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
      this.$nextTick(() => {
        this.$refs.loadingModalRef.showModal(true)
      })
      this.clearErrorMessages()
      this.getCustomName()
      this.getPriceData()
      this.modalInit = false
    },
    /** キャンセル */
    onCancel: function () {
      this.clearErrorMessages()
      this.initData()
      this.modalShown = false
    },
    /** 送信 */
    updateCostCustom: function () {
      this.clearErrorMessages()
      // 入力チェック
      let validList = []
      for (let i = 1; i <= 5; i++) {
        const count = i - 1
        validList.push(this.validCost(this.costCustom[i], 'costCustom' + i, this.customNameList[count]))
      }
      let isVarid = true
      validList.forEach(e => {
        if (!e) isVarid = e
      })
      if (!isVarid) return

      let payload = {
        estimatePriceType: this.priceType,
        planCustomCost1: this.checkEmpty(this.costCustom[1]),
        planCustomCost2: this.checkEmpty(this.costCustom[2]),
        planCustomCost3: this.checkEmpty(this.costCustom[3]),
        planCustomCost4: this.checkEmpty(this.costCustom[4]),
        planCustomCost5: this.checkEmpty(this.costCustom[5])
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/price-data/update', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        if (response.data.errorMessage) {
          // エラーメッセージ表示
          this.$emit('handleErrorMessage', response)
        } else {
          this.modalShown = false
          AppUtil.showModal({
            messages: ['変更しました。']
          })
          // this.$emit('setResponseData', response)
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /** 項目名の取得 */
    getCustomName: function () {
      axios.get(API_URL.ADMIN + '/get-cost-custom'
      ).then(response => {
        let data = response.data.data
        this.customNameList.push(data.costCustomName1 ? data.costCustomName1 : 'カスタム設定名１')
        this.customNameList.push(data.costCustomName2 ? data.costCustomName2 : 'カスタム設定名２')
        this.customNameList.push(data.costCustomName3 ? data.costCustomName3 : 'カスタム設定名３')
        this.customNameList.push(data.costCustomName4 ? data.costCustomName4 : 'カスタム設定名４')
        this.customNameList.push(data.costCustomName5 ? data.costCustomName5 : 'カスタム設定名５')
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 表示用価格データ取得 */
    getPriceData: function () {
      axios.get(API_URL.PREVIEW + '/price-data')
        .then(response => {
          if (response.data.errorMessage) {
            AppUtil.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            this.planPriceData = response.data.data
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 入力価格のバリデーションチェック（入力した値が整数であるか判定） */
    validCost: function (cost, key, errorMessage) {
      let pattern = /^[-]?([1-9]\d*|0)$/
      if (cost !== null && cost !== '' && (!pattern.test(cost) || String(cost).length > 9)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 入力価格の空欄チェック */
    checkEmpty: function (value) {
      if (value === null || value === '') {
        return 0
      }
      return value
    },
    /** エラーメッセージのクリア */
    clearErrorMessages: function () {
      this.validateErrorMessages = {}
    },
    /** データ初期化 */
    initData: function () {
      this.costCustom = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0}
    }
  }
}
</script>
<style lang="scss" scoped>
.cost-custom-modal{
  max-height: 100%;
  max-width: 530px;
}
.data-area{
  min-height: 300px;
  margin: 20px auto;
  li {
    margin: 20px auto;
  }
  .radio-area{
    text-align: left;
    margin: 0px 44px;
  }
  .label{
    min-width: 220px;
    display: inline-block;
    text-align: left;
  }
  .radio{
    min-width: 110px;
    display: inline-block;
  }
  .bs-input{
    width:180px;
  }
  .price{
    min-width: 205px;
  }
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetCostCustomModal.vue